import React from "react"
import { Link } from "gatsby"
import ReactWOW from "react-wow"
import scrollTo from "gatsby-plugin-smoothscroll"

const GetApproval = () => {
  return (
    <section id="support" className="get-approval">
      <div className="container">
        <div className="plain-section-wrapper">
          <div className="row">
            <div className="col-12">
              <h3 className="h3-careers">How can I get approval?</h3>
              <p>
                With Oxygen the process of applying for a SMSF loan is straight
                forward. We are here to help you along the way. Compared to a
                regular home loan, there are more documents you have to obtain
                and share with us, which can take some time in preparation.
              </p>
              <p>
                Reach out via the{" "}
                <a href="/contact/" target="_blank">
                  contact us form
                </a>{" "}
                to start the application.
              </p>
            </div>
            <div className="wr-action col-12 pt-4 d-flex flex-column flex-md-row justify-content-center align-items-center">
              <a
                href="/applynow"
                className="default-btn secondary-btn mr-md-3 mr-0 btn-lg"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GetApproval
